import React from 'react';
import "./heroSection.scss";
import AppImage from '../../../../common/features/image';

function LeftContent({ data }) {
  return (
    <>
      <div>
        <AppImage
          src={data.image_url}
          alt={data.title}
          className='common-hero-img'
        />
      </div>

      <div className='content-header-title'>
        {data.title}
      </div>

      <div className='content-paragraph'>
        {data.paragraphs.map((paragraph, index) => (
          <div key={index} style={{ padding: '8px 0'}}>
            {paragraph}
          </div>
        ))}
      </div>
    </>
  )
}

export default LeftContent;